import { Action } from "@ngrx/store";
import { ProfesionalId, TotalCapita } from "src/common/menuUsuario";

// Se definen acciones relacionadas a las opciones del menú del usuario que son dinámicas,
// es decir que se presentarán sólo si el usuario tiene acceso

export enum MenuUsuarioActionTypes {
	MenuUsuarioInitRequested = '[MenuUsuario Component] Menu Usuario Init Requested',

	AportePlanSaludInitRequested = '[MenuUsuario API] Aporte Plan Salud Init Requested',
	AportePlanSaludInitLoaded = '[MenuUsuario API] Aporte Plan Salud Init Loaded',
	AportePlanSaludInitCancelled = '[MenuUsuario API] Aporte Plan Salud Init Cancelled',

	ComprobanteTesoreriaInitRequested = '[MenuUsuario API] Comprobante Tesoreria Init Requested',
	ComprobanteTesoreriaInitLoaded = '[MenuUsuario API] Comprobante Tesoreria Init Loaded',
	ComprobanteTesoreriaInitCancelled = '[MenuUsuario API] Comprobante Tesoreria Init Cancelled',

	CapitaPacienteInitRequested = '[MenuUsuario API] Capita Paciente Init Requested',
	CapitaPacienteInitLoaded = '[MenuUsuario API] Capita Paciente Init Loaded',
	CapitaPacienteInitCancelled = '[MenuUsuario API] Capita Paciente Init Cancelled',

	IdPersonaSelectedChanged = '[MenuUsuario API] Id Persona Selected Changed'
}

export class MenuUsuarioInitRequested implements Action {
	readonly type: string = MenuUsuarioActionTypes.MenuUsuarioInitRequested;
	constructor() {
	}
}

// Aporte Plan Salud related actions
export class AportePlanSaludInitRequested implements Action {
	readonly type: string = MenuUsuarioActionTypes.AportePlanSaludInitRequested;
	constructor() {
	}
}

export class AportePlanSaludInitLoaded implements Action {
	readonly type: string = MenuUsuarioActionTypes.AportePlanSaludInitLoaded;
	constructor( public payload: { years: number[] } ) {
	}
}

export class AportePlanSaludInitCancelled implements Action {
	readonly type: string = MenuUsuarioActionTypes.AportePlanSaludInitCancelled;
	constructor() {
	}
}

// Comprobante related actions
export class ComprobanteTesoreriaInitRequested implements Action {
	readonly type: string = MenuUsuarioActionTypes.ComprobanteTesoreriaInitRequested;
	constructor() {
	}
}

export class ComprobanteTesoreriaInitLoaded implements Action {
	readonly type: string = MenuUsuarioActionTypes.ComprobanteTesoreriaInitLoaded;
	constructor( public payload: { profesionalIds: ProfesionalId[] } ) {
	}
}

export class ComprobanteTesoreriaInitCancelled implements Action {
	readonly type: string = MenuUsuarioActionTypes.ComprobanteTesoreriaInitCancelled;
	constructor() {
	}
}

// Cápita related actions
export class CapitaPacienteInitRequested implements Action {
	readonly type: string = MenuUsuarioActionTypes.CapitaPacienteInitRequested;
	constructor() {
	}
}

export class CapitaPacienteInitLoaded implements Action {
	readonly type: string = MenuUsuarioActionTypes.CapitaPacienteInitLoaded;
	constructor( public payload: TotalCapita ) {
	}
}

export class CapitaPacienteInitCancelled implements Action {
	readonly type: string = MenuUsuarioActionTypes.CapitaPacienteInitCancelled;
	constructor() {
	}
}

// Id Persona Selected related actions
export class IdPersonaSelectedChanged implements Action {
	readonly type: string = MenuUsuarioActionTypes.IdPersonaSelectedChanged;
	constructor( public payload: { idPersona: number } ) {}
}

export type MenuUsuarioAction = MenuUsuarioInitRequested |
	AportePlanSaludInitRequested | AportePlanSaludInitLoaded | AportePlanSaludInitCancelled |
	ComprobanteTesoreriaInitRequested | ComprobanteTesoreriaInitLoaded | ComprobanteTesoreriaInitCancelled |
	CapitaPacienteInitRequested | CapitaPacienteInitLoaded | CapitaPacienteInitCancelled |
	IdPersonaSelectedChanged;